/* eslint-disable array-callback-return */
import { Box, Flex, FormLabel, Heading } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import {
  createChapterRequest,
  editChapterRequest,
} from "../../../../modules/admin-modules/chapters/Actions";
import { closeCreateChapterModel } from "../../../../modules/admin-modules/models/Actions";
import { getAllAdminSectionsRequest } from "../../../../modules/admin-modules/sections/Actions";

const AddQuestionsWallet = ({ isAdd, data, setSelectedData, active = 0 }) => {
  const openChapter = useSelector((state) => state.model.isOpen11);
  const isLoading = useSelector((state) => state.chapters.isLoading);
  const sections = useSelector((state) => state.adminSections.sections);

  const sectionsOptions = sections?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const dispatch = useDispatch();
  useEffect(() => {
    if (openChapter) {
      dispatch(getAllAdminSectionsRequest());
    }
  }, [openChapter]);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: !isAdd ? data : {},
    shouldUnregister: true,
  });

  const sectionId = watch("section_id");
  const selectedSection =
    sectionsOptions?.find((option) => option.value == sectionId) || null;

  useEffect(() => {
    if (openChapter && !isAdd && data?.section_id && sections?.length) {
      setValue("section_id", data.section_id);
    }
  }, [openChapter, isAdd, data?.section_id, sections?.length, setValue]);

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? "إضافة حافظة الاسئلة" : "تعديل حافظة الاسئلة"}
      </Heading>
    </Box>
  );

  const onSubmit = async (values) => {
    const action = () => {
      dispatch(closeCreateChapterModel());
      setSelectedData({});
      reset();
    };

    if (isAdd) {
      let formData = await new FormData();
      for (let key in values) {
        formData.append(key, values[key]);
      }
      formData.append("active", active);
      if (values.section_id) {
        await dispatch(createChapterRequest(formData, action));
      } else {
        toast.error("اختر المادة");
      }
    } else {
      let formData = new FormData();
      formData.append("_method", "PUT");
      formData.append("name", values.name);
      formData.append("name_ar", values.name_ar);
      formData.append("section_id", values.section_id ?? data?.section_id);

      dispatch(
        editChapterRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateChapterModel());
    setSelectedData({});
    reset();
  };

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openChapter}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          dir="rtl"
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          gap="4"
        >
          <Box w="45%">
            <MainInput
              label="اسم حافظة الاسئلة باللغة الانجليزية"
              defaultValues={data?.name}
              error={errors?.name?.message}
              placeholder="ادخل اسم حافظة الاسئلة باللغة الانجليزية"
              register={register}
              name="name"
            />
          </Box>
          <Box w="45%">
            <MainInput
              label="اسم حافظة الاسئلة باللغة العربية"
              defaultValues={data?.name_ar}
              error={errors?.name_ar?.message}
              placeholder="ادخل اسم حافظة الاسئلة باللغة العربية"
              register={register}
              name="name_ar"
            />
          </Box>

          <Box w="45%">
            <Box w="100%">
              <FormLabel>الاقسام : </FormLabel>
              <Select
                key={isAdd ? "add-section" : `edit-section-${data?.id}`}
                options={sectionsOptions}
                value={selectedSection}
                onChange={(option) => setValue("section_id", option.value)}
                styles={colourStyles}
                placeholder="الاقسام"
              />
            </Box>
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddQuestionsWallet;
